import RecognizedRibbon from '../src/RecognizedRibbon';
export default RecognizedRibbon;
